import { axiosInstance } from '../../utils/fetcher';
import { API } from '../../api';

const CancelToken = axiosInstance.CancelToken;

let getShipmentDraftInfoServiceCancelToken = () => {};
export const getShipmentDraftInfoService = (data) => {
  getShipmentDraftInfoServiceCancelToken();
  return axiosInstance.request({
    url: `${API.POV}/GetShipmentInformation`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentDraftInfoServiceCancelToken = c;
    }),
  });
};
